import { ChunkDrawer } from '@/new/components/drawers/chunk-drawer';
import { DocumentDrawer } from '@/new/components/drawers/document-drawer';
import { FactWithDocumentDrawer } from '@/new/components/drawers/fact-with-document-drawer';
import { useStore } from '@/store';

export function ReferenceDrawer() {
  const { referenceDrawer, closeReferenceDrawer } = useStore();

  if (referenceDrawer.chunkId) {
    return (
      <ChunkDrawer chunkId={referenceDrawer.chunkId} isOpen={referenceDrawer.isOpen} onClose={closeReferenceDrawer} />
    );
  }

  if (referenceDrawer.factId) {
    return (
      <FactWithDocumentDrawer
        factId={referenceDrawer.factId}
        isOpen={referenceDrawer.isOpen}
        onClose={closeReferenceDrawer}
      />
    );
  }

  if (referenceDrawer.docId) {
    return (
      <DocumentDrawer docId={referenceDrawer.docId} isOpen={referenceDrawer.isOpen} onClose={closeReferenceDrawer} />
    );
  }
}
